module.exports = __webpack_public_path__ + "static/media/appstore.3a164d38.svg";